const TAG = "sc-image-load-fade";
const CLASS_FADE = "sc-image--load-fade";
const CLASS_READY = "sc-image--load-fade--ready";
const SELECTOR = `img.${CLASS_FADE}`;

const prefersReduceMotion = () =>
  globalThis.matchMedia?.("(prefers-reduced-motion: reduce)").matches === true;

/**
 * @param {HTMLImageElement} img
 */
function bindImage(img) {
  if (!(img instanceof HTMLImageElement) || img.classList.contains(CLASS_READY)) {
    return;
  }
  const mark = () => {
    img.classList.add(CLASS_READY);
  };
  if (prefersReduceMotion()) {
    mark();
    return;
  }
  if (img.complete && img.naturalWidth > 0) {
    mark();
    return;
  }
  img.addEventListener("load", mark, { once: true });
  img.addEventListener("error", mark, { once: true });
}

/**
 * @param {ParentNode} root
 */
function initInRoot(root) {
  root.querySelectorAll(SELECTOR).forEach((el) => {
    if (el instanceof HTMLImageElement) bindImage(el);
  });
}

if (!customElements.get(TAG)) {
  class ScImageLoadFade extends HTMLElement {
    #onSectionLoad = (/** @type {Event} */ e) => {
      const t = e.target;
      if (t instanceof HTMLElement) initInRoot(t);
    };

    /** @type {MutationObserver | null} */
    #mo = null;

    connectedCallback() {
      initInRoot(document);
      document.addEventListener("shopify:section:load", this.#onSectionLoad);
      this.#mo = new MutationObserver((records) => {
        for (const r of records) {
          for (const n of r.addedNodes) {
            if (n instanceof HTMLImageElement && n.classList?.contains(CLASS_FADE)) {
              bindImage(n);
            } else if (n instanceof Element) {
              n.querySelectorAll(SELECTOR).forEach((el) => {
                if (el instanceof HTMLImageElement) bindImage(el);
              });
            }
          }
        }
      });
      this.#mo.observe(document.body, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      document.removeEventListener("shopify:section:load", this.#onSectionLoad);
      this.#mo?.disconnect();
      this.#mo = null;
    }
  }
  customElements.define(TAG, ScImageLoadFade);
}
